import { orderXClient } from '@/service/client'
import { unwrapServerMessage } from '@/service/server-message'
import {
  ApiRequest,
  ChangeAccountRoleRequest,
  InviteToAccountRequest,
  ListAccountAccessResponse,
  ListMyInvitesResponse,
  RemoveAccountAccessRequest,
  RespondToInviteRequest,
  RevokeInviteRequest,
  ServerMessage,
  TransferAccountOwnershipRequest,
} from '@/types/generated/public_api'
import type { ErrorResponse } from '@/types/service'

async function postForSuccess(payload: Partial<ApiRequest>) {
  try {
    const { data } = await orderXClient.post<ServerMessage>('/api', payload)
    if (data.error) {
      return Promise.reject(data.error)
    }
    return unwrapServerMessage(data)
  } catch (e) {
    const error = e as ErrorResponse
    return Promise.reject(error)
  }
}

export async function fetchAccountAccess(accountId: string) {
  try {
    const { data } = await orderXClient.post<ServerMessage>('/api', {
      listAccountAccess: { accountId },
    })
    if (data.error) {
      return Promise.reject(data.error)
    }
    const response = data.listAccountAccessResponse
    if (!response) {
      return { accountId, members: [], pendingInvites: [] } as ListAccountAccessResponse
    }
    return response
  } catch (e) {
    const error = e as ErrorResponse
    return Promise.reject(error)
  }
}

export async function fetchMyInvites() {
  try {
    const { data } = await orderXClient.post<ServerMessage>('/api', { listMyInvites: {} })
    if (data.error) {
      return Promise.reject(data.error)
    }
    const response = data.listMyInvitesResponse
    if (!response) {
      return { invites: [] } as ListMyInvitesResponse
    }
    return response
  } catch (e) {
    const error = e as ErrorResponse
    return Promise.reject(error)
  }
}

export async function inviteToAccount(payload: InviteToAccountRequest) {
  return postForSuccess({ inviteToAccount: payload })
}

export async function revokeInvite(payload: RevokeInviteRequest) {
  return postForSuccess({ revokeInvite: payload })
}

export async function removeAccountAccess(payload: RemoveAccountAccessRequest) {
  return postForSuccess({ removeAccountAccess: payload })
}

export async function changeAccountRole(payload: ChangeAccountRoleRequest) {
  return postForSuccess({ changeAccountRole: payload })
}

export async function leaveAccount(accountId: string) {
  return postForSuccess({ leaveAccount: { accountId } })
}

export async function respondToInvite(payload: RespondToInviteRequest) {
  return postForSuccess({ respondToInvite: payload })
}

export async function transferAccountOwnership(payload: TransferAccountOwnershipRequest) {
  return postForSuccess({ transferAccountOwnership: payload })
}
